<!-- setting tabindex 1 to enable blur event. -->
<mat-list class="ds-list-with-actions" tabindex="1" (blur)="unselectItems()" #matList>
  <mat-list-item
    *ngFor="let item of items; let i = index"
    (click)="onSelect(item)"
    class="mat-list-item-divider"
    [ngClass]="{ 'mat-list-item-selected': selectedItems.includes(item) }"
  >
    <!-- we could create a ds-divider component to generalize this behavior. -->
    <ds-lib-vertical-divider
      class="byd-vertical-divider"
      *ngIf="selectedItems.includes(item)"
    ></ds-lib-vertical-divider>
    <mat-icon class="start-icon" *ngIf="leftIcon" [ngClass]="{ 'grey-icon': leftIconColor === 'grey' }">{{
      leftIcon
    }}</mat-icon>
    <span
      #nameSpan
      class="item-name"
      [ngClass]="{ bold: selectedItems.includes(item) }"
      [matTooltip]="item[properties.name]"
      [matTooltipDisabled]="
        tooltipOnNameOverflow === 0 ||
        (tooltipOnNameOverflow !== 0 && item[properties.name].length * fontSize < tooltipOnNameOverflow)
      "
    >
      {{ item[properties.name] }}
    </span>
    <div layout="row" layout-align="end center" flex>
      <button mat-icon-button *ngIf="canEdit" (click)="$event.stopPropagation(); onEdit(item)">
        <mat-icon class="action-button">edit</mat-icon>
      </button>
      <div
        *ngIf="canDelete"
        #deleteButtonDiv
        [matTooltip]="item[properties.cannotDelete] ? cannotDeleteTooltip : canDeleteTooltip"
      >
        <button
          mat-icon-button
          #deleteButton
          [disabled]="item[properties.cannotDelete]"
          class="action-button"
          (click)="$event.stopPropagation(); onDelete(item)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>
      <mat-icon *ngIf="rightChevron" class="right-chevron">chevron_right</mat-icon>
    </div>
  </mat-list-item>
</mat-list>
